import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate, useParams,  } from 'react-router-dom';
import queryString from 'query-string';

export const useQuery = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params: any = useParams();
    const query: { [key: string]: any } = useMemo(() => queryString.parse(location.search), [
        location.search,
    ]);

    const pushQuery = useCallback(
        (addQuery: { [key: string]: string | number | boolean }) => {
            const newQuery = { ...query, ...addQuery };
            navigate(location.pathname + `?${queryString.stringify(newQuery)}`);
        },
        [navigate, query],
    );

    const replaceQuery = useCallback(
        (addQuery: { [key: string]: string | number | boolean }) => {
            const newQuery = { ...query, ...addQuery };
            navigate(location.pathname + `?${queryString.stringify(newQuery)}`, {replace: true});
        },
        [navigate, query],
    );

    return {
        navigate,
        location,
        params,
        query,
        pushQuery,
        replaceQuery,
    };
};
